import React, { useEffect } from "react";
import { InputNumber, Checkbox, Input, Card, Button, Tooltip, Select } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons"
import NormalPayment from "../Payment/NormalPayment";
import ChequePayment from "../Payment/ChequePayment";
import EmiPayment from "../Payment/EmiPayment";
import AddExpensesSection from "../Payment/AddExpenses";
import { useSelector } from "react-redux";
import { selectAuthInfo } from "../../pages/Auth/authSelectors";
import { Grid } from "antd";
import AddExpensesFromSection from "../Payment/AddExpensesFrom";
import InputNumberField from "../Input/InputNumber";
import { getCurrencySymbol } from "../../lib/currency";
import { formatBulletText } from "../../lib/functions";

const { useBreakpoint } = Grid;



// styling helper function
const AmountRow = ({ symbol, label, value, currency, dataTestid = "", bold = false }) => {
  const screens = useBreakpoint();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 8,
        maxWidth: !screens.md ? "88%" : "60%",
      }}
      data-testid={dataTestid}
    >
      <span style={{ fontWeight: bold ? 600 : 400 }}>
        {/* {label} ({currency}): */}
        {label}:
      </span>
      <span style={{ fontWeight: bold ? 600 : 400 }}>
        {symbol}
        {Number(value || 0).toFixed(2)}
      </span>
    </div>
  )
};


const SharedFooter = ({
  footerValues,
  onFooterChange,
  defaultAccount,
  pageType,
  taxMode,
  conversionRate,
  conversionCurrency,
  servicePayCart = [],
  institution
}) => {

  const authInfo = useSelector(selectAuthInfo);
  const currency = authInfo?.currency;
  const symbol = getCurrencySymbol(
    conversionRate ? conversionCurrency : authInfo?.currency
  );
  const screens = useBreakpoint();
  // const conversionRate = useSelector((s) => s.purchaseEntry.conversionRate);
 const isIndia = authInfo?.country?.toLowerCase() === "india";
  const taxLabel = isIndia ? "GST" : "VAT";
  const gstEnabled = authInfo?.gst_enabled === "yes";
  const showTax = !isIndia || gstEnabled;
  const hasCheque = (footerValues?.payCart || []).some(
  (p) => p.acc_type_id === "cheque"
);

useEffect(() => {
  if (pageType === "purchaseEntry") {
    const hasCheque = (footerValues?.payCart || []).some(
      (p) => p.acc_type_id === "cheque"
    );

    if (footerValues?.paidAmount > 0 && !footerValues?.isCheque) {
      onFooterChange(true, "isCheque");
    }

    if (hasCheque && !footerValues?.isCheque) {
      onFooterChange(true, "isCheque");
    }
  }
}, [footerValues?.paidAmount, footerValues?.payCart]);


console.log(footerValues,"footerValuescheck");
  return (
    <div
      style={{
        display: screens.md ? "flex" : "block",
        justifyContent: "space-between",
        gap: 32,
      }}
    >
      {/* LEFT SIDE */}
      <div style={{ flex: 1 }}>
        {pageType === "productReplace" && (
          <AmountRow
            label="Return Amount"
            symbol={symbol}
            // currency={currency}
            value={
              conversionRate
                ? footerValues.returnTotal * conversionRate
                : footerValues.returnTotal
            }
          />
        )}
        {pageType === "productReplace" && (
          <AmountRow
            label="Given Item Amount"
            symbol={symbol}
            // currency={currency}
            value={
              conversionRate
                ? footerValues.givenTotal * conversionRate
                : footerValues.givenTotal
            }
          />
        )}
        {pageType === "productReplace" && (
          <AmountRow
            label="Total"
            symbol={symbol}
            // currency={currency}
            bold
            value={
              conversionRate
                ? footerValues.returnTotal -
                footerValues.givenTotal * conversionRate
                : footerValues.returnTotal - footerValues.givenTotal
            }
          />
        )}

        <div style={{ display: "flex", alignItems: "baseline" }}>
          {/* Payment checkboxes (skip for SalesOrder & SalesReturn , etc.) */}
          {pageType !== "serviceEntry" &&
            pageType !== "serviceExpense" &&
            pageType !== "purchaseReturn" &&
            pageType !== "pos" && (
              <Checkbox
                checked={footerValues.addExpenses}
                onChange={(e) =>
                  onFooterChange(e.target.checked, "addExpenses")
                }
                style={{ display: "flex", marginTop: 8, marginBottom: 20 }}
              >
                Additional Expenses
              </Checkbox>
            )}

          {pageType !== "quotation" &&
            pageType !== "salesReturn" &&
            pageType !== "productReplace" &&
            pageType !== "salesOrder" &&
            pageType !== "purchaseOrder" &&
            pageType !== "serviceEntry" &&
            pageType !== "serviceExpense" && (
              <>
                {pageType !== "purchaseEntry" &&
                  pageType !== "purchaseReturn" &&
                  pageType !== "productReplace" && (
                    <Checkbox
                      checked={footerValues?.isEMI}
                      onChange={(e) =>
                        onFooterChange(e.target.checked, "isEMI")
                      }
                      style={{ display: "flex", marginTop: 8 }}
                    >
                      EMI Payment
                    </Checkbox>
                  )}
                {pageType !== "pos" && pageType !== "purchaseReturn" &&(
                  <Checkbox
                    checked={footerValues.isCheque}
                    onChange={(e) =>
                      onFooterChange(e.target.checked, "isCheque")
                    }
                    style={{ display: "flex", marginTop: 4 }}
                  >
                    Payment
                  </Checkbox>
                )}
              </>
            )}
        </div>

        {/* Payment Components (skip in quotation, salesOrder, etc) */}

        <>
          {pageType !== "quotation" &&
            pageType !== "salesOrder" &&
            pageType !== "purchaseOrder" &&
            pageType !== "purchaseEntry" &&
            pageType !== "productReplace" &&
            pageType !== "purchaseReturn" &&
            footerValues?.paidAmount > 0 &&
            !footerValues?.isCheque &&
            !footerValues?.isEMI && (
              <NormalPayment
                onFooterChange={onFooterChange}
                defaultAccount={defaultAccount}
                value={footerValues.payCart}
                conversionRate={conversionRate}
              />
            )}
           
          {(
            (pageType === "productReplace" || pageType === "purchaseReturn")
              ? true
              : pageType !== "quotation" &&
                pageType !== "salesOrder" &&
                pageType !== "purchaseOrder" &&
                pageType !== "pos" &&
                pageType !== "salesReturn" &&
                footerValues?.isCheque
          ) && (
            <ChequePayment
              onFooterChange={onFooterChange}
              defaultAccount={defaultAccount}
              conversionRate={conversionRate}
              footerValues={footerValues}
              pageType={pageType}
            />
          )}

          {pageType !== "quotation" &&
            pageType !== "salesOrder" &&
            pageType !== "purchaseOrder" &&
            pageType !== "salesReturn" &&
            footerValues?.isEMI && (
              <EmiPayment
                onFooterChange={onFooterChange}
                salesVoucherNumber={footerValues?.salesVoucherNumber}
              />
            )}
        </>

        {footerValues?.addExpenses &&
          pageType !== "purchaseEntry" &&
          pageType !== "purchaseOrder" &&
          pageType !== "pos" && (
            <AddExpensesSection
              onFooterChange={onFooterChange}
              conversionRate={conversionRate}
              servicePayCart={footerValues?.payServiceCart || servicePayCart || []}
              // servicePayCart={footerValues?.payServiceCart || []}
            />
          )}
        {footerValues?.addExpenses &&
          pageType !== "salesReturn" &&
          pageType !== "quotation" &&
          pageType !== "salesOrder" &&
          pageType !== "productReplace" &&
          pageType !== "pos" && (
            <AddExpensesFromSection
              onFooterChange={onFooterChange}
              servicePayCart={footerValues?.payServiceCart || []}
              conversionRate={conversionRate}
            />
          )}
      </div>

      {/* RIGHT SIDE */}
      <div style={{ flex: 1 }}>
        <AmountRow
          label="Subtotal"
          symbol={symbol}
          // currency={currency}
          value={
            conversionRate
              ? footerValues.subtotal * conversionRate
              : footerValues.subtotal
          }
        />

        {/* Only if explicitly passed & on_total */}
        {(pageType === "quotation" ||
          pageType === "purchaseReturn") &&
          taxMode === "on_total" && (
            <>
              <div data-testid="discount-container">
                Discount %:{" "}
                <InputNumber
                  data-testid="discount-input"
                  min={0}
                  max={100}
                  value={footerValues.discountPct}
                  onChange={(val) => onFooterChange(val, "discountPct")}
                  style={{ width: "100%" }}
                  onWheel={(e) => e.target.blur()}
                />
              </div>

              {pageType !== "purchaseReturn" && showTax && (
                <div>
                  {taxLabel} %:{" "}
                  <InputNumber
                    min={0}
                    max={100}
                    value={authInfo?.item_tax || 0}
                    onChange={(val) => onFooterChange(val, "totalTax")}
                    style={{ width: "100%" }}
                    onWheel={(e) => e.target.blur()}
                    disabled
                  />
                </div>
              )}
            </>
          )}

        {/* Purchase Entry: percent-or-flat-amount discount toggle */}
        {pageType === "purchaseEntry" && taxMode === "on_total" && (
          <>
            <div
              data-testid="discount-container"
              style={{ display: "flex", flexDirection: "column", gap: 4 }}
            >
              <span>Discount:</span>
              <div style={{ display: "flex", gap: 8 }}>
                <Select
                  size="small"
                  style={{ width: 80 }}
                  value={footerValues.discountMode === "amount" ? "amount" : "percent"}
                  options={[
                    { label: "%", value: "percent" },
                    { label: "Amount", value: "amount" },
                  ]}
                  onChange={(v) => onFooterChange(v, "discountMode")}
                />
                {footerValues.discountMode === "amount" ? (
                  <InputNumber
                    data-testid="discount-amount-input"
                    min={0}
                    max={Number(footerValues.subtotal) || 0}
                    value={footerValues.discountAmt}
                    onChange={(val) => onFooterChange(val, "discountAmt")}
                    style={{ width: "100%" }}
                    onWheel={(e) => e.target.blur()}
                  />
                ) : (
                  <InputNumber
                    data-testid="discount-input"
                    min={0}
                    max={100}
                    value={footerValues.discountPct}
                    onChange={(val) => onFooterChange(val, "discountPct")}
                    style={{ width: "100%" }}
                    onWheel={(e) => e.target.blur()}
                  />
                )}
              </div>
            </div>

            {showTax && (
              <div>
                {taxLabel} %:{" "}
                <InputNumber
                  min={0}
                  max={100}
                  value={authInfo?.item_tax || 0}
                  onChange={(val) => onFooterChange(val, "totalTax")}
                  style={{ width: "100%" }}
                  onWheel={(e) => e.target.blur()}
                  disabled
                />
              </div>
            )}
          </>
        )}

        {/* Purchase Order: percent-or-flat-amount discount toggle */}
        {pageType === "purchaseOrder" && taxMode === "on_total" && (
          <>
            <div
              data-testid="discount-container"
              style={{ display: "flex", flexDirection: "column", gap: 4 }}
            >
              <span>Discount:</span>
              <div style={{ display: "flex", gap: 8 }}>
                <Select
                  size="small"
                  style={{ width: 80 }}
                  value={footerValues.discountMode === "amount" ? "amount" : "percent"}
                  options={[
                    { label: "%", value: "percent" },
                    { label: "Amount", value: "amount" },
                  ]}
                  onChange={(v) => onFooterChange(v, "discountMode")}
                />
                {footerValues.discountMode === "amount" ? (
                  <InputNumber
                    data-testid="discount-amount-input"
                    min={0}
                    max={Number(footerValues.subtotal) || 0}
                    value={footerValues.discountAmt}
                    onChange={(val) => onFooterChange(val, "discountAmt")}
                    style={{ width: "100%" }}
                    onWheel={(e) => e.target.blur()}
                  />
                ) : (
                  <InputNumber
                    data-testid="discount-input"
                    min={0}
                    max={100}
                    value={footerValues.discountPct}
                    onChange={(val) => onFooterChange(val, "discountPct")}
                    style={{ width: "100%" }}
                    onWheel={(e) => e.target.blur()}
                  />
                )}
              </div>
            </div>

            {showTax && (
              <div>
                {taxLabel} %:{" "}
                <InputNumber
                  min={0}
                  max={100}
                  value={authInfo?.item_tax || 0}
                  onChange={(val) => onFooterChange(val, "totalTax")}
                  style={{ width: "100%" }}
                  onWheel={(e) => e.target.blur()}
                  disabled
                />
              </div>
            )}
          </>
        )}

        {/* Sales Order: percent-or-flat-amount discount toggle */}
        {pageType === "salesOrder" && taxMode === "on_total" && (
          <>
            <div
              data-testid="discount-container"
              style={{ display: "flex", flexDirection: "column", gap: 4 }}
            >
              <span>Discount:</span>
              <div style={{ display: "flex", gap: 8 }}>
                <Select
                  size="small"
                  style={{ width: 80 }}
                  value={footerValues.discountMode === "amount" ? "amount" : "percent"}
                  options={[
                    { label: "%", value: "percent" },
                    { label: "Amount", value: "amount" },
                  ]}
                  onChange={(v) => onFooterChange(v, "discountMode")}
                />
                {footerValues.discountMode === "amount" ? (
                  <InputNumber
                    data-testid="discount-amount-input"
                    min={0}
                    max={Number(footerValues.subtotal) || 0}
                    value={footerValues.discountAmt}
                    onChange={(val) => onFooterChange(val, "discountAmt")}
                    style={{ width: "100%" }}
                    onWheel={(e) => e.target.blur()}
                  />
                ) : (
                  <InputNumber
                    data-testid="discount-input"
                    min={0}
                    max={100}
                    value={footerValues.discountPct}
                    onChange={(val) => onFooterChange(val, "discountPct")}
                    style={{ width: "100%" }}
                    onWheel={(e) => e.target.blur()}
                  />
                )}
              </div>
            </div>

            {showTax && (
              <div>
                {taxLabel} %:{" "}
                <InputNumber
                  min={0}
                  max={100}
                  value={authInfo?.item_tax || 0}
                  onChange={(val) => onFooterChange(val, "totalTax")}
                  style={{ width: "100%" }}
                  onWheel={(e) => e.target.blur()}
                  disabled
                />
              </div>
            )}
          </>
        )}

        {/* Service Entry: percent-or-flat-amount discount toggle */}
        {pageType === "serviceEntry" && taxMode === "on_total" && (
          <>
            <div
              data-testid="discount-container"
              style={{ display: "flex", flexDirection: "column", gap: 4 }}
            >
              <span>Discount:</span>
              <div style={{ display: "flex", gap: 8 }}>
                <Select
                  size="small"
                  style={{ width: 80 }}
                  value={footerValues.discountMode === "amount" ? "amount" : "percent"}
                  options={[
                    { label: "%", value: "percent" },
                    { label: "Amount", value: "amount" },
                  ]}
                  onChange={(v) => onFooterChange(v, "discountMode")}
                />
                {footerValues.discountMode === "amount" ? (
                  <InputNumber
                    data-testid="discount-amount-input"
                    min={0}
                    max={Number(footerValues.subtotal) || 0}
                    value={footerValues.discountAmt}
                    onChange={(val) => onFooterChange(val, "discountAmt")}
                    style={{ width: "100%" }}
                    onWheel={(e) => e.target.blur()}
                  />
                ) : (
                  <InputNumber
                    data-testid="discount-input"
                    min={0}
                    max={100}
                    value={footerValues.discountPct}
                    onChange={(val) => onFooterChange(val, "discountPct")}
                    style={{ width: "100%" }}
                    onWheel={(e) => e.target.blur()}
                  />
                )}
              </div>
            </div>

            {showTax && (
              <div>
                {taxLabel} %:{" "}
                <InputNumber
                  min={0}
                  max={100}
                  value={authInfo?.item_tax || 0}
                  onChange={(val) => onFooterChange(val, "totalTax")}
                  style={{ width: "100%" }}
                  onWheel={(e) => e.target.blur()}
                  disabled
                />
              </div>
            )}
          </>
        )}

        {/* Service Expense: percent-or-flat-amount discount toggle */}
        {pageType === "serviceExpense" && taxMode === "on_total" && (
          <>
            <div
              data-testid="discount-container"
              style={{ display: "flex", flexDirection: "column", gap: 4 }}
            >
              <span>Discount:</span>
              <div style={{ display: "flex", gap: 8 }}>
                <Select
                  size="small"
                  style={{ width: 80 }}
                  value={footerValues.discountMode === "amount" ? "amount" : "percent"}
                  options={[
                    { label: "%", value: "percent" },
                    { label: "Amount", value: "amount" },
                  ]}
                  onChange={(v) => onFooterChange(v, "discountMode")}
                />
                {footerValues.discountMode === "amount" ? (
                  <InputNumber
                    data-testid="discount-amount-input"
                    min={0}
                    max={Number(footerValues.subtotal) || 0}
                    value={footerValues.discountAmt}
                    onChange={(val) => onFooterChange(val, "discountAmt")}
                    style={{ width: "100%" }}
                    onWheel={(e) => e.target.blur()}
                  />
                ) : (
                  <InputNumber
                    data-testid="discount-input"
                    min={0}
                    max={100}
                    value={footerValues.discountPct}
                    onChange={(val) => onFooterChange(val, "discountPct")}
                    style={{ width: "100%" }}
                    onWheel={(e) => e.target.blur()}
                  />
                )}
              </div>
            </div>

            {showTax && (
              <div>
                {taxLabel} %:{" "}
                <InputNumber
                  min={0}
                  max={100}
                  value={authInfo?.item_tax || 0}
                  onChange={(val) => onFooterChange(val, "totalTax")}
                  style={{ width: "100%" }}
                  onWheel={(e) => e.target.blur()}
                  disabled
                />
              </div>
            )}
          </>
        )}

        {/* POS: percent-or-flat-amount discount toggle */}
        {pageType === "pos" && taxMode === "on_total" && (
          <>
            <div
              data-testid="discount-container"
              style={{ display: "flex", flexDirection: "column", gap: 4 }}
            >
              <span>Discount:</span>
              <div style={{ display: "flex", gap: 8 }}>
                <Select
                  size="small"
                  style={{ width: 80 }}
                  value={footerValues.discountMode === "amount" ? "amount" : "percent"}
                  options={[
                    { label: "%", value: "percent" },
                    { label: "Amount", value: "amount" },
                  ]}
                  onChange={(v) => onFooterChange(v, "discountMode")}
                />
                {footerValues.discountMode === "amount" ? (
                  <InputNumber
                    data-testid="discount-amount-input"
                    min={0}
                    max={Number(footerValues.subtotal) || 0}
                    value={footerValues.discountAmt}
                    onChange={(val) => onFooterChange(val, "discountAmt")}
                    style={{ width: "100%" }}
                    onWheel={(e) => e.target.blur()}
                  />
                ) : (
                  <InputNumber
                    data-testid="discount-input"
                    min={0}
                    max={100}
                    value={footerValues.discountPct}
                    onChange={(val) => onFooterChange(val, "discountPct")}
                    style={{ width: "100%" }}
                    onWheel={(e) => e.target.blur()}
                  />
                )}
              </div>
            </div>

            {showTax && (
              <div>
                {taxLabel} %:{" "}
                <InputNumber
                  min={0}
                  max={100}
                  value={authInfo?.item_tax || 0}
                  onChange={(val) => onFooterChange(val, "totalTax")}
                  style={{ width: "100%" }}
                  onWheel={(e) => e.target.blur()}
                  disabled
                />
              </div>
            )}
          </>
        )}

        {/* <div>
          Service Charge:{" "}
          <InputNumber
            value={footerValues.serviceCharge}
            onChange={(val) => onFooterChange(val, "serviceCharge")}
            style={{ width: "100%" }}
          />
        </div> */}

        <AmountRow
          label="Grand Total"
          dataTestid="grand-total"
          // currency={currency}
          symbol={symbol}
          bold
          value={
            conversionRate
              ? footerValues.grandTotal * conversionRate
              : footerValues.grandTotal
          }
        />

        {/* Paid/Due Amount (skip in quotation, salesOrder, etc) */}
        {pageType !== "quotation" &&
          pageType !== "salesOrder" &&
          pageType !== "purchaseOrder" && (
            <>
              <div>
                Paid Amount ({currency}):{" "}
                <InputNumber
                  precision={2}
                  // value={parseFloat(
                  //   conversionRate
                  //     ? (footerValues?.paidAmount || 0) * conversionRate
                  //     : (footerValues?.paidAmount || 0)
                  // )?.toFixed(2)}
                  value={
                    footerValues?.paidAmount == null
                      ? undefined
                      : conversionRate
                        ? footerValues.paidAmount * conversionRate
                        : footerValues.paidAmount
                  }
                  onFocus={() => {
                    onFooterChange(undefined, "paidAmount");
                  }}
                  onBlur={() => {
                    if (footerValues?.paidAmount == null) {
                      onFooterChange(0, "paidAmount");
                    }
                  }}
                  onChange={(val) => {
                    const originalRate = conversionRate
                      ? val / conversionRate
                      : val;
                    onFooterChange(originalRate, "paidAmount");
                  }}
                  style={{ width: "100%" }}
                  onWheel={(e) => e.target.blur()}
                  data-testid="paid-amount-input"
                />
              </div>
              <AmountRow
                label="Due Amount"
                symbol={symbol}
                // currency={currency}
                value={
                  conversionRate
                    ? footerValues.dueAmount * conversionRate
                    : footerValues.dueAmount
                }
              />
            </>
          )}

        <div style={{ marginTop: 8 }}>
          Description:{" "}
          <Input.TextArea
            value={footerValues?.description || ""}
            onChange={(e) => onFooterChange(e.target.value, "description")}
            rows={3}
          />
        </div>

          {(pageType === "quotation") && (
            <>
              <div style={{ marginTop: 16 }}>
                <Checkbox
                  checked={footerValues.showTermsAndConditions}
                  onChange={(e) =>
                    onFooterChange(
                      e.target.checked,
                      "showTermsAndConditions"
                    )
                  }
                >
                  <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    marginBottom: 4,
                  }}
                >
                  <span>Include Terms & Conditions</span>
                   <Tooltip
                      title="Enable to show Terms & Conditions and Payment Terms in printed quotation."
                    >
                      <InfoCircleOutlined
                        style={{
                          marginLeft: 6,
                          color: "#999",
                          cursor: "pointer",
                        }}
                      />
                    </Tooltip>
                </div>
                  
                </Checkbox>

                {footerValues.showTermsAndConditions &&
                <Button
                  size="small"
                  style={{ marginLeft: 10 }}
                  onClick={() => {
                    onFooterChange(
                      institution?.quotation_terms || "",
                      "termsConditions"
                    );

                    onFooterChange(
                      institution?.quotation_payment_terms || "",
                      "paymentTerms"
                    );
                  }}
                >
                  Restore Default
                </Button>}
              </div>

              {footerValues.showTermsAndConditions && (
                <>
                  <div style={{ marginTop: 12 }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        marginBottom: 4,
                      }}
                    >
                      <span>Terms & Conditions:</span>

                      <Tooltip
                        title="Enter one condition per line. Each line will appear as a bullet point in print/PDF."
                      >
                        <InfoCircleOutlined
                          style={{
                            color: "#999",
                            cursor: "pointer",
                          }}
                        />
                      </Tooltip>
                    </div>

                    <Input.TextArea
                      // rows={6}
                      autoSize={{ minRows: 6, maxRows: 12 }}
                      placeholder={`Enter one term per line

                      Example:
                      18% TAX extra
                      Offer valid for 30 days
                      Delivery within 10 days`}
                      value={footerValues.termsConditions || ""}
                      onChange={(e) =>
                        onFooterChange(
                          formatBulletText(e.target.value),
                          "termsConditions"
                        )
                      }
                      style={{
                        backgroundImage:
                          "linear-gradient(to bottom, #f1f1f1 1px, transparent 1px)",
                        backgroundSize: "100% 32px",
                        lineHeight: "32px",
                      }}
                    />
                  </div>

                  <div style={{ marginTop: 12 }}>
                    <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                      marginBottom: 4,
                    }}
                  >
                    <span>Payment Terms:</span>  
                    <Tooltip
                        title="Enter one condition per line. Each line will appear as a bullet point in print/PDF."
                      >
                        <InfoCircleOutlined
                          style={{
                            color: "#999",
                            cursor: "pointer",
                          }}
                        />
                      </Tooltip>
                    </div>                  

                    <Input.TextArea
                      // rows={4}
                      autoSize={{ minRows: 4, maxRows: 10 }}
                      placeholder={`Enter one term per line

                      Example:
                      50% Advance
                      Remaining After Delivery`}
                      value={footerValues.paymentTerms || ""}
                      onChange={(e) =>
                        onFooterChange(
                          formatBulletText(e.target.value),
                          "paymentTerms"
                        )
                      }
                      style={{
                        backgroundImage:
                          "linear-gradient(to bottom, #f1f1f1 1px, transparent 1px)",
                        backgroundSize: "100% 32px",
                        lineHeight: "32px",
                      }}
                    />
                  </div>
                </>
    )}
  </>
)}

      {pageType === "purchaseOrder" && (
        <>
          <div style={{ marginTop: 16 }}>
            <Checkbox
              checked={footerValues.showTermsConditions}
              onChange={(e) =>
                onFooterChange(
                  e.target.checked,
                  "showTermsConditions"
                )
              }
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <span>Include Payment Terms</span>

                <Tooltip
                  title="Enable to show payment terms in printed purchase order."
                >
                  <InfoCircleOutlined
                    style={{
                      color: "#999",
                      cursor: "pointer",
                    }}
                  />
                </Tooltip>
              </div>
            </Checkbox>

            {footerValues.showTermsConditions && (
              <Button
                size="small"
                style={{ marginLeft: 10 }}
                onClick={() => {
                  onFooterChange(
                    institution?.purchase_order_payment_terms || "",
                    "paymentTermsDescription"
                  );
                }}
              >
                Restore Default
              </Button>
            )}
          </div>

          {footerValues.showTermsConditions && (
            <div style={{ marginTop: 12 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  marginBottom: 4,
                }}
              >
                <span>Payment Terms:</span>

                <Tooltip
                  title="Enter one condition per line. Each line will appear as a bullet point in print/PDF."
                >
                  <InfoCircleOutlined
                    style={{
                      color: "#999",
                      cursor: "pointer",
                    }}
                  />
                </Tooltip>
              </div>

              <Input.TextArea
                autoSize={{ minRows: 4, maxRows: 10 }}
                placeholder={`Enter one term per line

      Example:
      50% Advance
      Remaining After Delivery`}
                value={footerValues.paymentTermsDescription || ""}
                onChange={(e) =>
                  onFooterChange(
                    formatBulletText(e.target.value),
                    "paymentTermsDescription"
                  )
                }
                style={{
                  backgroundImage: "linear-gradient(to bottom, #f1f1f1 1px, transparent 1px)",
                  backgroundSize: "100% 32px",
                  lineHeight: "32px",
                  overflowY: "auto",
                  paddingRight: 12,
                }}
              />
            </div>
          )}
        </>
      )}


      </div>
    </div>
  );
};

export default SharedFooter;
